import { useSelector } from "react-redux"
import { selectReaderManager } from "../../ReaderManagerEvents/ReaderManagerSlice"
import { READING_MODES } from "../../../../constants/constants"
export default function useReadingMode() {

  const { contextStates } = useSelector(selectReaderManager)
  const { readingMode } = contextStates

  return {
    readingMode,
    isTutorMode: readingMode === READING_MODES.TUTOR,
    isAssessmentMode: readingMode === READING_MODES.ASSESSMENT,
  }
}